import { TextField } from '@mui/material'
import React from 'react'

export default function SupTextArea({ item }) {
  return (
    <>
      <TextField
        size="small"
        value={item.textareaValue}
        fullWidth
        disabled
        inputProps={{
          maxLength: 100,
          style: { fontSize: '1rem', height: 30, color: 'black !important', backgroundColor: 'hsl(0, 0%, 95%)' },
        }}
      />
    </>
  )
}
